export const locale = {
    lang: 'pl',
    data: {
        'DELETE': 'Usuń',
        'EDIT': 'Edycja',
        'SAVE': 'Zapisz',
        'Cancel': 'Anuluj',
        'CANCEL': 'Anuluj',
        'Confirm': 'Potwierdź',
        'Are you sure you want to left current window?': 'Czy na pewno chcesz opuścić bieżące okno?',
        'Confirm deletion': 'Potwierdź usunięcie',
        'Are you sure you want to delete selected gallery?': 'Czy na pewno chcesz usunąć wybraną galerię?',
        'Resource': 'Zasób'
    }
};
